import { cx } from "@linaria/core";
import * as React from "react";

/**
 * The underlying DOM element which is rendered by this component.
 */
const Root = "div";
interface Props extends React.ComponentProps<typeof Root> {}
function Grid(props: Props, ref: React.ForwardedRef<React.ComponentRef<typeof Root>>) {
  const {
    children,
    className,
    ...rest
  } = props;
  return <Root ref={ref} className={cx(className, classes.root)} {...rest}>
      {children}
    </Root>;
}
export default React.forwardRef(Grid);
const classes = {
  root: "r1c1ozpm"
};

require("./Grid.linaria.module.css!=!../../../../node_modules/.pnpm/@wyw-in-js+webpack-loader@0.6.0_webpack@5.99.5/node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Grid.tsx");